import React from 'react';
import { Search } from 'lucide-react';
import { SearchBarProps } from './types';

export function SearchBar({ onOpen }: SearchBarProps) {
  return (
    <button
      onClick={onOpen}
      className="p-2 border border-[#001642] dark:border-gray-600 text-[#001642] hover:bg-[#001642] dark:hover:bg-primary-100 hover:text-white dark:text-gray-300 rounded-full transition-colors flex items-center space-x-2 group"
    >
      <Search size={20} className="text-[#001642] group-hover:text-white dark:text-gray-100 transition-colors" />
      <span className="hidden md:inline text-sm">Pesquisar</span>
      <kbd className="hidden md:inline-flex h-5 items-center gap-1 rounded border border-[#001642] dark:border-gray-600 bg-white dark:bg-gray-800 px-1.5 font-mono text-[10px] font-medium text-[#001642] dark:text-gray-100">
        CTRL+K
      </kbd>
    </button>
  );
}